<div class="card" (mouseover)="mouseover()" (mouseout)="mouseout()" [@cardFlip]="data.state">
    <div class="face back">
        <img [src]="img" />
        <h3 >{{name}}</h3>
    </div>
    <div class="face front">
        <p>{{text}}</p>
    </div>
</div>